export default __webpack_public_path__ + "static/media/text-size.b59bb6f5.svg";